import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-377379bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "auth-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spotlight-container" }, [
  /*#__PURE__*/_createElementVNode("header", null, [
    /*#__PURE__*/_createElementVNode("img", { src: "https://static.caderio.com/assets/logos/chatcaptain-logo.png" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "spotlight" }, [
    /*#__PURE__*/_createElementVNode("img", { src: "https://chatcaptain.de/assets/img/interbots/light--grosse-lasten.svg" })
  ])
], -1))
const _hoisted_4 = { class: "auth-form-wrapper" }
const _hoisted_5 = { class: "switch-view-action" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Account erstellen")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Willkommen zurück!", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Melde dich mit deinem Google-Konto an oder gebe deine E-Mail-Adresse und dein Passwort ein.", -1))
const _hoisted_9 = { class: "fields" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Mit Google anmelden")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", null, "oder")
], -1))
const _hoisted_12 = { class: "button-wrapper" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Passwort vergessen?")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Jetzt anmelden")
const _hoisted_15 = {
  key: 0,
  class: "overlay"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legal" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://chatcaptain.com/imprint.html",
    target: "_blank"
  }, "Impressum"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://chatcaptain.com/privacy.html",
    target: "_blank"
  }, "Datenschutz"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://chatcaptain.com/sbt.html",
    target: "_blank"
  }, "AGB")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_auth_provider_sign_in_button = _resolveComponent("auth-provider-sign-in-button")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_input_field_wrapper = _resolveComponent("md-input-field-wrapper")!
  const _component_md_progress_indicator_circular = _resolveComponent("md-progress-indicator-circular")!
  const _component_transition_fade = _resolveComponent("transition-fade")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/sign-up" }, {
            default: _withCtx(() => [
              _createVNode(_component_md_button, { variant: "outlined" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("form", {
          class: "auth-form",
          onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args)), ["enter"]))
        }, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_auth_provider_sign_in_button, { logo: _ctx.GoogleIcon }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["logo"]),
            _hoisted_11,
            _createVNode(_component_md_input_field_wrapper, null, {
              default: _withCtx(() => [
                _createVNode(_component_md_input_field, {
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  "input-validator": _ctx.emailValidator,
                  ref: "email",
                  variant: "filled",
                  type: "email",
                  label: "E-Mail-Adresse",
                  icon: "email"
                }, null, 8, ["modelValue", "input-validator"])
              ]),
              _: 1
            }),
            _createVNode(_component_md_input_field_wrapper, null, {
              default: _withCtx(() => [
                _createVNode(_component_md_input_field, {
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  "input-validator": _ctx.passwordValidator,
                  ref: "password",
                  variant: "filled",
                  type: "password",
                  icon: "lock",
                  label: "Passwort"
                }, null, 8, ["modelValue", "input-validator"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, { to: "/password-recovery" }, {
              default: _withCtx(() => [
                _createVNode(_component_md_button, { variant: "text" }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_md_button, {
              variant: "filled",
              type: "submit",
              onClick: _ctx.signIn
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_transition_fade, null, {
            default: _withCtx(() => [
              (_ctx.overlayVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_md_progress_indicator_circular, { size: "large" })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 32),
        _hoisted_16
      ])
    ])
  ]))
}